import { useState, useContext, useEffect, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaTimes, FaPlus, FaChevronDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../styles/selectpay.css";
import Account from '../components/Account';

const Withdraw = () => {
  const { currentUser, fetchBankAccounts } = useContext(AuthContext);
  const navigate = useNavigate();

  const [amount, setAmount] = useState("");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [amountError, setAmountError] = useState("");
  const [accountError, setAccountError] = useState("");

  const amountRef = useRef(null);
  const accountRef = useRef(null);

  useEffect(() => {
    const loadAccounts = async () => {
      const result = await fetchBankAccounts();
      if (!result.error) {
        setBankAccounts(result.bankAccounts);
      } else {
        console.error(result.error);
      }
    };
    loadAccounts();
  }, [fetchBankAccounts]);

  const handleReview = () => {
    setAmountError("");
    setAccountError("");

    const numericAmount = parseInt(amount, 10);

    if (!amount) {
      setAmountError("Amount is required.");
      amountRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (numericAmount < 5000) {
      setAmountError("⚠️ Minimum withdrawal is ₦5,000.");
      amountRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (numericAmount > 10000) {
      setAmountError("⚠️ Maximum withdrawal is ₦10,000.");
      amountRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (!selectedAccount) {
      setAccountError("Please select a bank account.");
      accountRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    const totalCost = numericAmount - Math.ceil(numericAmount * 0.2); // 20% fee rounded up


    navigate("/review", {
      state: {
        type: "withdraw",
        details: {
          amount: numericAmount,
          payeeBankCode: selectedAccount.bankCode,
          payeeBankAccNo: selectedAccount.accountNumber,
          payeeName: selectedAccount.accountName,
          payeePhoneNo: currentUser?.phone || "",
          remark: `Withdrawal by ${currentUser?.username || "User"}`,
          totalCost: totalCost, // 👈 updated here
        },
      },
    });
  };

  return (
    <div>
      <Account />

      <div className="withdraw-container">

        {/* Amount Input */}
        <div ref={amountRef}>
          <label className="network-label">Amount</label>
          <input
            required
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={5}
            placeholder="Amount"
            value={amount}
            onChange={(e) => {
              const raw = e.target.value;
              if (/^\d{0,5}$/.test(raw)) {
                const numeric = parseInt(raw || "0", 10);
                if (numeric <= 10000) {
                  setAmount(raw);
                }
              }
            }}
            className="input-field"
          />
          {amountError && <p className="error-input">{amountError}</p>}
        </div>

        {/* Bank Account Dropdown */}
        <div className = "account-adj" ref={accountRef}>
          <label className="network-label">Bank Account</label>
          <div
            className="dropdown-selector styled-select dg-bg"
            onClick={() => setIsDropdownOpen(true)}
          >
            <span>
              {selectedAccount ? (
                <>
                  {selectedAccount.accountName.toUpperCase()}
                  <br />
                  <strong>{selectedAccount.accountNumber}</strong>
                </>
              ) : (
                "Select Bank Account"
              )}
            </span>
          </div>
          {accountError && <p className="error-input">{accountError}</p>}
        </div>

        {isDropdownOpen && (
          <div className="dropdown-container">
            <div className="dropdown-close" onClick={() => setIsDropdownOpen(false)}>
              <FaTimes />
            </div>
            <p className="dropdown-title">Bank Account</p>
            <p className="dropdown-subtext">Select a bank account</p>

            {bankAccounts.map((account) => (
              <div
                key={account._id}
                className="saved-account-card"
                onClick={() => {
                  setSelectedAccount(account);
                  setIsDropdownOpen(false);
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="account-name" style={{ fontWeight: "bold" }}>
                  {account.accountName}
                </div>
                <div className="bank-name">{account.bankName.toUpperCase()}</div>
                <div className="account-number">{account.accountNumber}</div>
              </div>
            ))}

            <button
              onClick={() => navigate("/add-bank-account")}
              className="add-bank-button"
            >
              <FaPlus className="add-icon" />
              Add a Bank Account
            </button>
          </div>
        )}

        {!isDropdownOpen && (
          <button onClick={handleReview} className="withdraw-button">
            Withdrawal
          </button>
        )}
      </div>
    </div>
  );
};

export default Withdraw;
